/**
 * Created by staffanrantzow on 10/11/16.
 */

import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { SupplierLedgerService } from 'frilans-finans';
import { GeneralError } from 'components';
import ErrorMessage from '../../../../../components/error-message/error-message';

class SupplierLedgerTypePicker extends React.Component {

  static propTypes = {
    typeId: PropTypes.any,
    setType: PropTypes.func.isRequired,
    hsd: PropTypes.object.isRequired,
    showErrorWithoutBlur: PropTypes.bool,
    errorMessage: PropTypes.string
  };

  constructor (props) {
    super(props);

    this.state = {
      fetching: true,
      fetchError: false,
      types: [],
      typeEntities: [],
      selectValue: ''
    };

    this.handleResponse = this.handleResponse.bind(this);
    this.setType = this.setType.bind(this);
    this.renderOption = this.renderOption.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    // Used to reset the select
    if (nextProps.typeId === 'default') {
      this.setState({
        selectValue: nextProps.typeId
      });
    }
  }

  componentDidMount () {
    this.fetchTypes();
  }

  fetchTypes () {
    SupplierLedgerService.getTypes()
      .then(this.handleResponse)
      .catch(() => {
        this.setState({
          fetching: false,
          fetchError: true
        });
      });
  }

  handleResponse (types) {
    let t = [];

    for (let type of types) {
      t.push({
        disabled: false,
        id: type.id,
        name: type.displayName,
        taxId: type.taxId,
        value: type.id,
        isRotRut: type.isRotRut
      });
    }

    this.setState({
      types: t,
      typeEntities: types,
      fetching: false,
      fetchError: false
    });
  }

  setType (e) {
    this.setState({
      selectValue: e.target.value
    });

    if (!parseInt(e.target.value)) {
      this.props.setType(false);
    } else {
      for (let type of this.state.typeEntities) {
        if (parseInt(type.id) === parseInt(e.target.value)) {
          this.props.setType(type);
          break;
        }
      }
    }
  }

  renderOption (type, i) {
    let isRotOrRutInvoice = this.props.hsd.rot || this.props.hsd.rut;
    let shouldRender = (type.isRotRut && isRotOrRutInvoice) || !type.isRotRut;

    // Render depending on type
    if (shouldRender) {
      return (
        <option
          disabled={type.disabled}
          value={type.value}
          key={i}>
          <Translate content={'DEDUCTION_CATEGORY_' + type.id}/>
        </option>
      );
    }
  }

  render () {
    if (this.state.fetchError) {
      return <GeneralError/>;
    }
    if (this.state.types.length > 0) {
      return (
        <div className="input-wrapper">
          <div className=''>
            <div className='styled-select'>
              <select
                name='type-picker'
                value={this.state.selectValue ? this.state.selectValue : 'default'}
                onChange={this.setType}>
                <option><Translate content='PICK_DEDUCTION_CATEGORY'/></option>
                {this.state.types.map(this.renderOption)}
              </select>
              <label htmlFor="type-picker"><Translate content='DEDUCTION_CATEGORY'/></label>
            </div>
          </div>
          <ErrorMessage
            show={!!this.props.showErrorWithoutBlur && !!this.props.errorMessage}
            errorMessage={this.props.errorMessage}/>
        </div>
      );
    }

    return false;
  }

}

export default SupplierLedgerTypePicker;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/supplier-ledger/form/supplier-ledger-type-picker.js
 **/